import { ConfirmationModal } from '@/components/modals/ConfirmationModal'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  loading: boolean
}

export function WebReopenModal({ isOpen, onClose, onConfirm, loading }: Props) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      title="Reopen Web"
      message="Reopening will allow editing of online event details, speakers, and schedule. Changes won't sync to BigMarker until the next sign-off."
      type="warning"
      confirmText="Reopen"
      onConfirm={onConfirm}
      onCancel={onClose}
      loading={loading}
    />
  )
}
